import { createFileRoute } from '@tanstack/react-router';
import CancelarContrato from '../../-components/opcoes/cancelar-contrato';

export const Route = createFileRoute(
  '/__authenticated/comercial/produto/clientes/web/$codigo/cancelar-contrato',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { cliente } = Route.useRouteContext();

  return <CancelarContrato cliente={cliente} />;
}
